import React from 'react'
import { Helmet } from 'react-helmet-async'
import CssBaseline from '@material-ui/core/CssBaseline'
import {
    Switch,
    Route
} from "react-router-dom"
import TestPage from '../test/TestPage'
import PssDemo from '../PssDemo'
import { Typography } from '@material-ui/core'

const GOOGLE_APIS_FONTS_ROBOTO = 'https://fonts.googleapis.com/css?family=Roboto:300,400,500'
const GOOGLE_APIS_FONTS_BODONI_MODA = 'https://fonts.googleapis.com/css2?family=Bodoni+Moda:ital,opsz@0,6..96;1,6..96&display=swap'

export default ({
    isInitialized,
    windowTitle = "PSS",
    storeTargetTest,
    storeTargetSession,
}) =>
    <React.Fragment>
        <CssBaseline />
        <Helmet>
            <html lang="it-IT" />
            <link rel="stylesheet" href={GOOGLE_APIS_FONTS_ROBOTO} />
            <link rel="stylesheet" href={GOOGLE_APIS_FONTS_BODONI_MODA} />
            <title>{windowTitle}</title>
        </Helmet>
        <Switch>
            <Route path="/">
                <PssDemo storeTarget={storeTargetSession} />
            </Route>
            <Route path="/test">
                <TestPage storeTarget={storeTargetTest} />
            </Route>
            <Route path="/boh">
                {
                    isInitialized ?
                        <Typography> My react isInitialized </Typography>
                        : <Typography> My react NOT isInitialized </Typography>
                }
            </Route>
        </Switch>
    </React.Fragment>
